<template>
  <div>
    <el-row
      :gutter="20"
      class="activities-options">
      <el-col
        :span="6">
        <el-form-item label="Rubro">
          <el-select
            v-model="firstActivity"
            filterable
            placeholder="Rubro"
            class="option-activity"
            @change="onSelectedFirstActivity">
            <el-option
              v-for="(item,index) in firstOption"
              :key="index"
              :label="item.label"
              :value="item.value"/>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="Categoria">
          <el-select
            v-model="secondActivity"
            :disabled="first"
            filterable
            placeholder="Categoria"
            class="option-activity"
            @change="onSelectedSecondActivity">
            <el-option
              v-for="item in secondOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="7">
        <el-form-item label="Actividad">
          <el-select
            v-model="thirdActivity"
            :disabled="second"
            filterable
            placeholder="Actividad"
            class="option-activity">
            <el-option
              v-for="item in thirdOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item
          label="Superficie">
          <el-input
            v-model="surfaceActivity"
            type="number"
            placeholder="Hectareas"/>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col>
        <el-button @click="addActivity">Agregar actividad</el-button>
      </el-col>
      <el-col>
        <div class="activityName">
          <template v-for="(tag, index) of listActivities">
            <el-tag
              v-if="!tag.remove"
              :key="index"
              :disable-transitions="false"
              closable
              type="info"
              @close="handleClose(tag)">
              {{ tag.name }} {{ tag.surface > 0 ? parseFloat(tag.surface).toFixed(1) : 0 }} Ha.
            </el-tag>
          </template>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'CustomersActivities',
  props: {
    oldCustomer: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      /// /activities////
      firstOption: [],
      secondOption: [],
      thirdOption: [],
      firstActivity: null,
      secondActivity: null,
      thirdActivity: null,
      first: true,
      second: true,
      listActivities: [],
      listNameActivity: [],
      surfaceActivity: null
    }
  },
  mounted () {
    this.$store.dispatch('activities/query', {
      'filters[whereNull]': 'activityId'
    }).then(({data}) => {
      for (let item of data.items) {
        this.firstOption.push({
          label: item.name,
          value: item.id
        })
      }
    })

    if (this.oldCustomer.hasOwnProperty('id')) {
      this.$store.dispatch('customerActivities/query', {
        'filters[where][customerId][eq]': this.oldCustomer.id
      }).then(({data}) => {
        for (let item of data.items) {
          this.listActivities.push({
            activity: item.activityId,
            surface: item.surface,
            old: true
          })
        }
        this.showActivity()
      })
    }
  },
  methods: {
    addActivity () {
      if (this.thirdActivity !== null) {
        if (this.surfaceActivity === null) {
          this.listActivities.push({
            activity: this.thirdActivity,
            surface: 0
          })
        } else {
          this.listActivities.push({
            activity: this.thirdActivity,
            surface: this.surfaceActivity
          })
        }
        this.$emit('listActivity', this.listActivities)
        this.showActivity()
      } else {
        this.$message.error('Debe seleccionar una alguna actividad')
      }
      this.firstActivity = null
      this.secondActivity = null
      this.thirdActivity = null
      this.surfaceActivity = null
    },
    showActivity () {
      for (let i = 0; i < this.listActivities.length; i++) {
        this.$store.dispatch('activities/get', {
          id: this.listActivities[i].activity
        }).then(({data}) => {
          this.$set(this.listActivities[i], 'name', data.name)
        })
      }
    },
    onSelectedFirstActivity () {
      this.first = false
      this.secondOption = []
      this.$store.dispatch('activities/query', {
        'filters[where][activityId][eq]': this.firstActivity
      }).then(({data}) => {
        for (let item of data.items) {
          this.secondOption.push({
            label: item.name,
            value: item.id
          })
        }
      })
    },
    onSelectedSecondActivity () {
      this.second = false
      this.thirdOption = []
      this.$store.dispatch('activities/query', {
        'filters[where][activityId][eq]': this.secondActivity
      }).then(({data}) => {
        for (let item of data.items) {
          this.thirdOption.push({
            label: item.name,
            value: item.id
          })
        }
      })
    },
    handleClose (tag) {
      let index = this.listActivities.indexOf(tag)
      if (this.listActivities[index].old) {
        this.$set(this.listActivities[index], 'remove', true)
      } else {
        this.listActivities.splice(index, 1)
      }
      this.$emit('listActivity', this.listActivities)
    },
    activitiesSelected () {
      this.$emit('activitiesSelected', this.thirdActivity)
    }
  }
}
</script>

<style scoped lang="scss">
  .activities-options{
    margin-top: 20px;
    .option-activity{
      width: 100%;
      margin-bottom: 15px;
    }
  }
  .activityName{
    margin-top: 15px;
    padding: 10px 0 10px 0;
    display: flex;
    flex-flow: row wrap;
    .el-tag{
      margin-right: 10px;
      margin-top: 10px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/modules/customers/customers-activities.vue